// extracted by mini-css-extract-plugin
module.exports = {"featured":"FeaturedPosts_featured__1SKE4","featured__content":"FeaturedPosts_featured__content__2as8Y","featured__img":"FeaturedPosts_featured__img__3Oa-f"};